import React from 'react';
import BrowsingCardName from "../../../productCard/common/BrowsingCardName";
import ProductRates from "../../../productCard/common/ProductRates";
import TableHeading from "../../../TableHeading";

import clsx from 'clsx';
import CarrierLogo from "../../../productCard/common/CarrierLogo";
import Spinner from "../../../Spinner";
import { isVersionAdditionallyConfigured } from "../../utils";
import { createStyles } from "./styles";
import BcActionBlock from "../BcActionBlock";

/**
 * Create TableHeading or div with inner content that need to be wrapped in TableHeading,
 * but with general title for some products or variants
 */
var ProposalTableHeading = function ProposalTableHeading(_ref)















{var portfolio = _ref.portfolio,_ref$productName = _ref.productName,productName = _ref$productName === void 0 ? '' : _ref$productName,isPortfolioAddedToCart = _ref.isPortfolioAddedToCart,imProductId = _ref.imProductId,rates = _ref.rates,variantsAmount = _ref.variantsAmount,bcIndex = _ref.bcIndex,browsingShortName = _ref.browsingShortName,disabled = _ref.disabled,showWideColumns = _ref.showWideColumns,loaderInPortfolioId = _ref.loaderInPortfolioId,highlightBCAndConfigurePortfolio = _ref.highlightBCAndConfigurePortfolio,removeButton = _ref.removeButton,addButton = _ref.addButton,configureButton = _ref.configureButton;
  var productsAmount = portfolio.products.length;
  var classes = createStyles({ variantsAmount: variantsAmount, productsAmount: productsAmount, showWideColumns: showWideColumns });
  var isVersionConfigured = isVersionAdditionallyConfigured(portfolio, bcIndex);

  var BCTag = isVersionConfigured ? /*#__PURE__*/
  React.createElement("div", { className: classes.versionWrapper }, /*#__PURE__*/
  React.createElement("span", { className: classes.version }, "Variant ".concat(bcIndex + 1)), /*#__PURE__*/
  React.createElement("p", { className: clsx(classes.bcTag, classes.additionalTag) }, "Additional")) : /*#__PURE__*/


  React.createElement("div", { className: classes.versionWrapper }, /*#__PURE__*/
  React.createElement("span", { className: classes.version }, "Variant ".concat(bcIndex + 1)), /*#__PURE__*/
  React.createElement("p", { className: clsx(classes.bcTag, classes.defaultTag) }, "Default"));



  var actionButton = function actionButton() {
    if (removeButton && addButton) {
      return /*#__PURE__*/(
        React.createElement("div", null,
        isPortfolioAddedToCart ?
        removeButton(portfolio.id, bcIndex, disabled) :
        addButton(portfolio.id, bcIndex, portfolio.name, disabled),
        !isVersionConfigured &&
        configureButton &&
        configureButton(portfolio.id, bcIndex, portfolio.name, disabled)));


    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };

  /**
   * Heading inner content for portfolio with 1 product and some variants
   */
  var multiVariantsHeader = /*#__PURE__*/
  // div is used because it will be a part in the table heading, as general portfolio title is needed
  React.createElement("div", {
    className: clsx(classes.variantsHeading, disabled && classes.disabledCell),
    key: "heading_".concat(imProductId) }, /*#__PURE__*/

  React.createElement(BrowsingCardName, {
    name: highlightBCAndConfigurePortfolio ? undefined : "Variant ".concat(bcIndex + 1),
    title: highlightBCAndConfigurePortfolio ? BCTag : undefined,
    wrapperStyles: clsx(classes.portfolioNameWrapper, classes.variantNameWrapper),
    isPortfolioInProposal: isPortfolioAddedToCart,
    showSelectedIcon: !!(addButton && removeButton) }), /*#__PURE__*/

  React.createElement(ProductRates, {
    id: imProductId,
    rates: rates,
    styles: classes.ratesList,
    highlightColorStyle:
    highlightBCAndConfigurePortfolio ?
    isVersionConfigured ?
    classes.ratesConfigColor :
    undefined :
    undefined }), /*#__PURE__*/


  React.createElement(BcActionBlock, {
    actionButton: actionButton(),
    browsingShortName: browsingShortName,
    styles: classes.bcActionBlock }));




  /**
   * Heading inner content for portfolio with some products
   */
  var multiProductsHeader = /*#__PURE__*/
  React.createElement(React.Fragment, null,
  variantsAmount === 1 ? /*#__PURE__*/
  React.createElement("div", {
    className: clsx(classes.variantsHeading, disabled && classes.disabledCell),
    key: "heading_".concat(imProductId) }, /*#__PURE__*/

  React.createElement(BrowsingCardName, {
    name: productName,
    wrapperStyles: classes.productName,
    isPortfolioInProposal: false,
    showSelectedIcon: false }), /*#__PURE__*/

  React.createElement(ProductRates, { id: imProductId, rates: rates, styles: classes.ratesList })) : /*#__PURE__*/


  React.createElement("div", {
    className: clsx(classes.variantsHeading, disabled && classes.disabledCell),
    key: "heading_".concat(imProductId) }, /*#__PURE__*/

  React.createElement(BrowsingCardName, {
    name: productName,
    wrapperStyles: classes.productName,
    isPortfolioInProposal: isPortfolioAddedToCart,
    showSelectedIcon: false }), /*#__PURE__*/

  React.createElement(ProductRates, { id: imProductId, rates: rates, styles: classes.ratesList })));





  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    productsAmount > 1 && multiProductsHeader,

    variantsAmount > 1 && productsAmount === 1 && multiVariantsHeader,

    productsAmount === 1 && variantsAmount === 1 && /*#__PURE__*/
    React.createElement(TableHeading, { className: classes.proposalTableHeading, key: "heading_".concat(imProductId) }, /*#__PURE__*/
    React.createElement("div", { className: clsx(classes.headingContent, disabled && classes.disabledCell) }, /*#__PURE__*/
    React.createElement(CarrierLogo, { carrier: portfolio.products[0].carrier, styles: classes.portfolioLogo }), /*#__PURE__*/

    React.createElement(BrowsingCardName, {
      name: portfolio.name,
      wrapperStyles: clsx(classes.portfolioNameWrapper),
      isPortfolioInProposal: isPortfolioAddedToCart,
      showSelectedIcon: !!(addButton && removeButton) }),

    highlightBCAndConfigurePortfolio && /*#__PURE__*/
    React.createElement("div", { className: clsx(classes.portfolioNameWrapper, classes.variantNameWrapper) },
    BCTag), /*#__PURE__*/


    React.createElement(ProductRates, { id: imProductId, rates: rates, styles: classes.ratesList }), /*#__PURE__*/
    React.createElement(BcActionBlock, {
      actionButton: actionButton(),
      browsingShortName: browsingShortName,
      styles: classes.bcActionBlock })),


    loaderInPortfolioId === portfolio.id && /*#__PURE__*/
    React.createElement("div", { className: classes.spinnerWrapper }, /*#__PURE__*/
    React.createElement(Spinner, { size: "8rem" })))));






};

export default ProposalTableHeading;
//# sourceMappingURL=index.js.map